import { change, unregisterField, untouch } from "redux-form";
import store from "store";
import _ from "lodash";

export const RemoveField = (form, property, parent = null, value = null) => {
  store.dispatch(change(form, property, value ? value : ""));
  store.dispatch(untouch(form, property));
  store.dispatch(unregisterField(form, property));

  if (parent) {
    const formVal = _.get(
      store.getState().form,
      `${form}.values.${parent}`,
      {}
    );

    if (Object.keys(formVal).length < 1) {
      store.dispatch(change(form, parent, ""));
      return true;
    } else {
      return false;
    }
  }

  return false;
};

export const FormHasErrors = (form, ignoreList) => {
  let formErrors = {
    ..._.get(store.getState().form, `${form}.syncErrors`, null)
  };
  if (Object.keys(formErrors).length < 1) return false;

  ignoreList.map(i => {
    const propList = i.split(".");

    const prop = _.get(formErrors, propList, "uselessstring");

    if (checkEmptyness(prop)) {
      formErrors = _.omit(formErrors, propList);
    }

    return i;
  });

  if (Object.keys(formErrors).length > 0) {
    return true;
  }

  return false;
};

const checkEmptyness = obj => {
  return (
    !obj ||
    (Array.isArray(obj) && obj.length < 1) ||
    Object.keys(obj).length < 1
  );
};



// WEBPACK FOOTER //
// ./src/helpers/ReduxHelpers.js